module.exports = __webpack_public_path__ + "static/img/logo21.3487483.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo21.png
// module id = cA6I
// module chunks = 1